import React from "react"; 
import Keyboard from "react-simple-keyboard";

import "react-simple-keyboard/build/css/index.css";

const KeyboardManager = ({ getInput }) => {

    return (
        <Keyboard
          onChange={getInput}
          layout={{
            default: [
              "Q W E R T Y U I O P",
              "A S D F G H J K L",
              "{buy} Z X C V B N M {bksp}"
            ],
          }}
          display={{
            "{bksp}": "⌫",
            "{buy}": "🛒"
          }}
        />
      );

};

export default KeyboardManager;